module.exports = __webpack_public_path__ + "static/media/western_lotto.ad639e4d.png";